import { useNavigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { BillerBayLogo } from '@/components/ui/BillerBayLogo';
import { usePageTitle } from '@/hooks/usePageTitle';

export function MfaSetupRequiredPage() {
  usePageTitle('MFA Required');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-bb-bg p-4">
      <div className="w-full max-w-md bg-white shadow-sm border border-bb-lilac/40 p-8 text-center">
        <div className="flex flex-col items-center mb-6">
          <BillerBayLogo variant="dark" height={32} className="mb-4" />
          <span className="inline-flex items-center justify-center w-14 h-14 bg-bb-navy/10 mb-4">
            <ShieldCheck size={28} className="text-bb-navy" />
          </span>
          <h1 className="text-lg font-semibold text-slate-800">MFA Required</h1>
          <p className="text-sm text-slate-500 mt-2">
            Your organization requires Multi-Factor Authentication. Please set up an authenticator
            app to continue.
          </p>
        </div>

        <button
          type="button"
          className="login-btn w-full"
          onClick={() => navigate('/profile')}
        >
          Set Up MFA
        </button>
      </div>
    </div>
  );
}
